import css from 'styled-jsx/css';

const styles = css.global`.custom-carousel.embla {
  overflow: visible;
  max-width: 100%;
  position: relative;
}

.custom-carousel.embla.hide-overflow {
  overflow: hidden;
}

.custom-carousel.fill-height,
.custom-carousel .fill-height {
  height: 100%;
}

.custom-carousel .embla__container {
  display: flex;
}

.custom-carousel .embla__slide {
  position: relative;
  flex: 0 0 100%;
  margin: 0;
}

.custom-carousel .embla__prev {
  background: none;
  border: none;
  background-color: transparent;
  width: 24px;
  height: 40px;
  opacity: 1;
  background-size: 24px 40px;
  outline: none;
  border: none;
  cursor: pointer;
  background-image: url('static/amp/shared/assets/ic_arrow_l.svg');
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
}

.custom-carousel .embla__next {
  background: none;
  border: none;
  background-color: transparent;
  width: 24px;
  height: 40px;
  opacity: 1;
  background-size: 24px 40px;
  outline: none;
  border: none;
  cursor: pointer;
  background-image: url('static/amp/shared/assets/ic_arrow_r.svg');
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
}

.custom-carousel .embla__prev,
.custom-carousel .embla__next {
  display: none;
  padding: 8px;
  width: calc(24px + 16px);
  height: calc(40px + 16px);
  background-repeat: no-repeat;
  background-position: center;
  transition: opacity 0.233s ease-in;
  opacity: 1;
}

.custom-carousel .embla__prev.big-arrow,
.custom-carousel .embla__next.big-arrow {
  padding: 16px;
  width: calc(58px + 32px);
  height: calc(98px + 32px);
  background-size: 58px 98px;
  opacity: 0.5;
}

.custom-carousel .embla__prev.big-arrow {
  background-image: url('static/amp/shared/assets/seta-big-left.png');
}

.custom-carousel .embla__next.big-arrow {
  background-image: url('static/amp/shared/assets/seta-big-right.png');
}

.custom-carousel .embla__prev.disabled,
.custom-carousel .embla__next.disabled {
  opacity: 0;
}

.custom-carousel .embla__prev.enable-mobile-arrows,
.custom-carousel .embla__next.enable-mobile-arrows {
  display: block;
  padding: 0;
  width: 32px;
  height: 32px;
  background-size: 32px 32px;
  box-sizing: content-box;
}

.custom-carousel .embla__prev.enable-mobile-arrows {
  background-image: url('assets/seguro/ic_arrow_left.svg');
}

.custom-carousel .embla__next.enable-mobile-arrows {
  background-image: url('assets/seguro/ic_arrow_right.svg');
}

@media (min-width: 992px) {
  .custom-carousel .embla__prev,
  .custom-carousel .embla__next {
    display: block;
  }

  .custom-carousel .embla__prev.enable-mobile-arrows,
  .custom-carousel .embla__next.enable-mobile-arrows {
    width: 48px;
    height: 48px;
    background-size: 48px 48px;
  }
}
`;

export default styles;